/**
 * Created by henian.xu on 2018/7/19.
 *
 */

import CertExamApply from './CertExamApply';
import CertExamApplyRemarks from './CertExamApplyRemarks';
import VerticalGrouping from './VerticalGrouping';
import CertExamExam from './CertExamExam';
import CertExamApplyPaper from './CertExamApplyPaper';
import CertExamExamRecognition from './CertExamExamRecognition';
import SubsidyGrouping from './SubsidyGrouping';
import SubsidyApply from './SubsidyApply';
import VgTrainingPlan from './VgTrainingPlan';
import TrainingPlanTemplate from './TrainingPlanTemplate';
import TrainingPlanTemplateDetail from './TrainingPlanTemplateDetail';
import TrainingPlanProgram from './TrainingPlanProgram';
import DeferredReviewApply from './DeferredReviewApply';
import DeferredReviewGrouping from './DeferredReviewGrouping';
import SupplementApply from './SupplementApply';
import SupplementGrouping from './SupplementGrouping';
import CertExamApplyCourseRecognition from './CertExamApplyCourseRecognition';
import VerticalGroupingHistory from './VerticalGroupingHistory';
import CertificateReceiveDetail from './CertificateReceiveDetail';
import CertificateReceiveBatch from './CertificateReceiveBatch';
import VerticalGroupingApply from './VerticalGroupingApply';
import CertExamApplyCourseLog from './CertExamApplyCourseLog';
import Evaluate from './Evaluate';
import EvaluateTemplate from './EvaluateTemplate';
import Survey from './Survey';
import SurveyItem from './SurveyItem';
import AdmitCardTemplate from './AdmitCardTemplate';
import ExamineeAdmitCard from './ExamineeAdmitCard';

export default {
    CertExamApply,
    CertExamApplyRemarks,
    VerticalGrouping,
    CertExamExam,
    CertExamApplyPaper,
    CertExamExamRecognition,
    SubsidyGrouping,
    SubsidyApply,
    VgTrainingPlan,
    TrainingPlanTemplate,
    TrainingPlanTemplateDetail,
    TrainingPlanProgram,
    DeferredReviewApply,
    DeferredReviewGrouping,
    SupplementApply,
    SupplementGrouping,
    CertExamApplyCourseRecognition,
    VerticalGroupingHistory,
    CertificateReceiveDetail,
    CertificateReceiveBatch,
    VerticalGroupingApply,
    CertExamApplyCourseLog,
    Evaluate,
    EvaluateTemplate,
    Survey,
    SurveyItem,
    AdmitCardTemplate,
    ExamineeAdmitCard,
};
